import { Fragment, useEffect, useRef, useState } from "react";
import styles from "./ChangePassForAdmin.module.css";
import classNames from "classnames/bind";
import { Button, Col, HeaderModal, Input, Loading, Row, Toast } from "../../../../components";
import { PasswordIconSolid } from "../../../../components/Icons/Icons";
import { authenticator } from "../../../../services/api/authenticator";

const cx = classNames.bind(styles);

function ChangePassForAdmin({ open, infoUser, onClose }) {
    const [newPass, setNewPass] = useState('');
    const [confirmPass, setConfirmPass] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const refModal = useRef(null);
    const handleSubmitForm = async () => {
        try {
            setLoading(true)
            setIsSubmit(!isSubmit)
            const infoChange = {
                company_code: infoUser[0]?.COMPANY_CODE,
                password: newPass,
                username: infoUser[0]?.USERNAME
            }
            const res = await authenticator.changePassForAdmin(infoChange);
            setLoading(false);
            Toast.open("Thay đổi mật khẩu thành công", "success");
            onClose()
        } catch (error) {
            setLoading(false);
            Toast.open("Thay đổi mật khẩu không thành công", "danger");
            // // console.log('handleSubmitForm', error);
        }
    }

    const handleChangeNewPass = (value) => {
        setNewPass(value);
        setIsSubmit(!isSubmit)
    }
    const handleChangeConfirmPass = (value) => {
        setConfirmPass(value);
        setIsSubmit(!isSubmit)
    }
    const handleSubmit = () => {
        setIsSubmit(!isSubmit)
    }
    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (refModal && e.target === refModal?.current) {
                onClose();
            }
        };
        document.addEventListener("click", handleCloseOnClickOutSide);
        return () => {
            document.removeEventListener("click", handleCloseOnClickOutSide);
        };
        // eslint-disable-next-line
    }, []);
    return (
        <Fragment>
            {open ? (
                <div className={cx("wrapper")} ref={refModal}>
                    <div className={cx('container')}>
                        <HeaderModal onClose={onClose} title={"Đổi mật khẩu cho người dùng"} />
                        <Row className={cx('form-password')} style={{ justifyContent: 'center' }}>
                            <Col span={10}>
                                <form className={cx('form-change-password')} onSubmit={handleSubmitForm}>
                                    <Input
                                        placeholder="Nhập mật khẩu mới"
                                        type="password"
                                        onChange={handleChangeNewPass}
                                        value={newPass}
                                        rules={[
                                            {
                                                required: true,
                                                mess: "Mật khẩu mới không được trống!",
                                            },
                                            {
                                                min: 6,
                                                mess: "Mật khẩu từ 6 đến 20 ký tự!",
                                            },
                                            {
                                                max: 20,
                                                mess: "Mật khẩu từ 6 đến 20 ký tự!",
                                            },
                                            {
                                                password: true,
                                                mess: "Mật khẩu dài 6 - 20 ký tự không chứa khoảng trắng hoặc ký tự có dấu",
                                            },
                                        ]}
                                        icon={<PasswordIconSolid />}
                                        setIsSubmit={handleSubmit}
                                        isSubmit={isSubmit}
                                        stylesMessage={{
                                            margin: 0
                                        }}
                                    />
                                    <Input
                                        placeholder="Nhập lại mật khẩu mới"
                                        type="password"
                                        onChange={handleChangeConfirmPass}
                                        value={confirmPass}
                                        rules={[
                                            {
                                                required: true,
                                                mess: "Mật khẩu không được trống!",
                                            },
                                            {
                                                min: 6,
                                                mess: "Mật khẩu từ 6 đến 20 ký tự!",
                                            },
                                            {
                                                max: 20,
                                                mess: "Mật khẩu từ 6 đến 20 ký tự!",
                                            },
                                            {
                                                password: true,
                                                mess: "Mật khẩu dài 6 - 20 ký tự không chứa khoảng trắng hoặc ký tự có dấu",
                                            },
                                        ]}
                                        icon={<PasswordIconSolid />}
                                        setIsSubmit={handleSubmit}
                                        isSubmit={isSubmit}
                                        stylesMessage={{
                                            margin: 0
                                        }}
                                    />
                                    <Button
                                        onClick={handleSubmitForm}
                                        title="Xác nhận"
                                    />
                                </form>
                            </Col>
                        </Row>
                    </div>
                    {loading && (<div className={cx("loading-modal")}>
                        <Loading />
                    </div>)}
                </div>
            ) : (
                <>
                </>
            )}
        </Fragment>
    )
}

export default ChangePassForAdmin;